<template>
  <a-page
    :image_source="image_source"
    :image_height="image_height"
    :title="hotel_name"
  >
    <template v-slot:header_options>
      <div v-if="loading" class="d-flex align-center">
        <v-skeleton-loader type="text" style="width: 100px"></v-skeleton-loader>
        <v-skeleton-loader
          type="text"
          style="width: 100px"
          class="mx-2"
        ></v-skeleton-loader>
        <v-skeleton-loader type="text" style="width: 100px"></v-skeleton-loader>
      </div>
      <div v-else>
        <div class="d-flex align-center">
          <div class="d-flex align-center">
            <!-- Selector de periodo -->
            <v-menu
              v-model="periodMenu"
              :close-on-content-click="false"
              offset-y
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  class="mx-2"
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  outlined
                >
                  <v-icon small class="mr-2">mdi-calendar</v-icon>
                  {{ periodLabel }}
                </v-btn>
              </template>

              <v-card>
                <v-list>
                  <v-list-item @click="sales_period = 'current_month'">
                    <v-list-item-avatar class="mr-0">
                      <v-icon>mdi-view-dashboard-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ $t("this_month") }}
                        <span
                          class="grey--text text-caption text-capitalize ml-1"
                          >{{ this_month + " " + this_year }}</span
                        ></v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item @click="sales_period = 'current_year'">
                    <v-list-item-avatar class="mr-0">
                      <v-icon>mdi-calendar-blank-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ $t("this_year") }}
                        <span class="grey--text text-caption ml-1">{{
                          this_year
                        }}</span></v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item @click="openPastDialog">
                    <v-list-item-avatar class="mr-0">
                      <v-icon>mdi-history</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ $t("Past") }}
                        <span class="grey--text text-caption ml-1">{{
                          $t("select")
                        }}</span></v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>

            <!-- <v-chip small color="secondary" class="mx-2">
              VS
            </v-chip> -->

            <!-- Aquí irá el segundo selector -->
            <!-- Selector de comparativa -->
            <v-menu
              v-model="compareMenu"
              :close-on-content-click="false"
              offset-y
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on" rounded outlined>
                  <v-icon small class="mr-2">mdi-poll</v-icon>
                  {{ compareLabel }}
                </v-btn>
              </template>

              <v-card>
                <v-list>
                  <v-list-item @click="sales_vs = 'presupuesto'">
                    <v-list-item-avatar class="mr-0">
                      <v-icon>mdi-file-chart-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t("bud") }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item @click="sales_vs = 'ano_pasado'">
                    <v-list-item-avatar class="mr-0">
                      <v-icon>mdi-arrow-left</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $t("Last_year")
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item @click="openRestaurantDialog">
                    <v-list-item-avatar class="mr-0">
                      <v-icon>mdi-silverware-fork-knife</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ $t("Other_restaurant")
                        }}<span class="grey--text text-caption ml-1">{{
                          $t("select")
                        }}</span></v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </div>

          <div style="max-width: 250px;" v-if="tabs.length > 0">
            <v-select
              v-model="tab_view"
              :items="tabs"
              item-value="id"
              class="ml-4"
              color="#fff"
              rounded
              outlined
              dense
              hide-details
            >
              <template v-slot:[`item`]="{ item }">
                <v-icon>
                  {{ item.icon }}
                </v-icon>
                <span class="ml-2">
                  {{ item.name }}
                </span>
              </template>
              <template v-slot:[`selection`]="{ item }">
                <v-icon>
                  {{ item.icon }}
                </v-icon>
                <span class="ml-2">
                  {{ item.name }}
                </span>
              </template>
            </v-select>
          </div>
        </div>
      </div>
    </template>

    <!-- Diálogo para seleccionar un periodo pasado -->
    <v-dialog v-model="pastPeriodDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline">
          {{ $t("select_past_period") }}
          <v-spacer></v-spacer>
          <v-btn icon @click="pastPeriodDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-tabs v-model="activeYearTab" centered grow>
            <v-tab v-for="year in availableYears" :key="year">
              {{ year }}
            </v-tab>

            <v-tabs-items v-model="activeYearTab">
              <v-tab-item v-for="year in availableYears" :key="year">
                <v-card flat>
                  <v-card-text>
                    <!-- Botón ver todo el año -->
                    <div
                      class="text-center my-4"
                      v-if="getMonthsForYear(year).length > 0"
                    >
                      <v-btn
                        color="secondary"
                        class="white--text"
                        rounded
                        @click="selectFullYear(year)"
                      >
                        {{ $t("view_full_year") }}
                      </v-btn>
                    </div>

                    <!-- Grid de meses -->
                    <v-row>
                      <v-col
                        v-for="month in getMonthsForYear(year)"
                        :key="`${month}-${year}`"
                        cols="6"
                        sm="4"
                        md="2"
                        class="pa-1"
                      >
                        <v-btn
                          block
                          color="secondary"
                          class="white--text text-none"
                          :class="{
                            'purple darken-2':
                              sales_period === 'past' &&
                              sales_period_month === month &&
                              parseInt(sales_period_year) === parseInt(year)
                          }"
                          rounded
                          @click="selectPastMonth(month, year)"
                        >
                          {{ getMonthName(month) }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogo para seleccionar otro restaurante -->
    <v-dialog v-model="restaurantDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline">
          {{ $t("select_hotel_to_compare") }}
          <v-spacer></v-spacer>
          <v-btn icon @click="restaurantDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-tabs v-model="activeRestaurantGroupTab" centered grow>
            <v-tab
              v-for="group in restaurantGroups"
              :key="'tab-group-' + group.id"
            >
              {{ group.name }}
            </v-tab>

            <v-tabs-items v-model="activeRestaurantGroupTab">
              <v-tab-item
                v-for="group in restaurantGroups"
                :key="'tab-item-' + group.id"
              >
                <v-card flat>
                  <v-card-text>
                    <!-- Grid de restaurantes -->
                    <v-row
                      v-if="
                        restaurantsByGroup[group.id] &&
                          restaurantsByGroup[group.id].length > 0
                      "
                      align="center"
                      justify="center"
                    >
                      <v-col
                        v-for="restaurant in restaurantsByGroup[group.id]"
                        :key="restaurant.id"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        class="pa-2"
                      >
                        <v-btn
                          block
                          color="secondary"
                          class="white--text"
                          rounded
                          @click="selectRestaurant(restaurant.id)"
                        >
                          {{ restaurant.name }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col cols="12" class="text-center">
                        <p class="grey--text text--darken-1">
                          {{ $t("no_selectable_restaurants") }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>

    <restaurant-sales-app
      ref="restaurant-sales-app"
      :tab_view="tab_view"
    ></restaurant-sales-app>
  </a-page>
</template>

<script>
import aPage from "@/components/aPage";
import restaurantSalesApp from "@/components/app/restaurantSalesApp";
import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "restaurant-sales",
  components: {
    aPage,
    restaurantSalesApp
  },
  data: () => ({
    image_source: "/img/header.jpg", // Mandatory path
    periodMenu: false,
    pastPeriodDialog: false,
    compareMenu: false,
    restaurantDialog: false,
    tab_view: "resume",
    loading: true,
    activeYearTab: 0,
    activeRestaurantGroupTab: 0
  }),
  computed: {
    this_year() {
      return Vue.moment().format("YYYY");
    },
    this_month() {
      return Vue.moment().format("MMMM");
    },
    hotel_name() {
      return this.current_hotel ? this.current_hotel.name : "";
    },
    tabs() {
      return [
        {
          name: this.$t("Resume"),
          id: "resume",
          icon: "mdi-card-multiple-outline"
        },
        { name: this.$t("Table"), id: "table", icon: "mdi-table-large" }
      ];
    },

    // Grupos de restaurantes para el selector
    restaurantGroups() {
      // Retornar todos los hoteles que tengan hijos (children_number > 0)
      return this.hotels
        .filter(hotel => hotel.children_number > 0)
        .map(hotel => ({
          id: hotel.id,
          name: hotel.name
        }));
    },

    // Restaurantes agrupados por grupo
    restaurantsByGroup() {
      const result = {};

      // Inicializar grupos vacíos
      this.restaurantGroups.forEach(group => {
        result[group.id] = [];
      });

      this.hotels.forEach(hotel => {
        // Solo incluir si es hijo directo de algún grupo
        if (hotel.father_id) {
          const parentGroup = this.restaurantGroups.find(
            group => group.id === hotel.father_id
          );
          if (parentGroup) {
            result[parentGroup.id].push(hotel);
          }
        }
      });

      return result;
    },

    // Variables computadas con getters y setters para el store
    sales_period: {
      get() {
        return this.$store.state.restaurant.sales_period;
      },
      set(value) {
        this.$store.commit("SET_SALES_PERIOD", value);
      }
    },
    sales_period_month: {
      get() {
        return this.$store.state.restaurant.sales_period_month;
      },
      set(value) {
        this.$store.commit("SET_SALES_PERIOD_MONTH", value);
      }
    },
    sales_period_year: {
      get() {
        return this.$store.state.restaurant.sales_period_year;
      },
      set(value) {
        this.$store.commit("SET_SALES_PERIOD_YEAR", value);
      }
    },
    sales_vs: {
      get() {
        return this.$store.state.restaurant.sales_vs;
      },
      set(value) {
        this.$store.commit("SET_SALES_VS", value);
      }
    },
    sales_hotel_vs: {
      get() {
        return this.$store.state.restaurant.sales_hotel_vs;
      },
      set(value) {
        this.$store.commit("SET_SALES_HOTEL_VS", value);
        this.$store.commit(
          "SET_SALES_HOTEL_VS_NAME",
          this.hotels.find(h => h.id === value).name
        );
      }
    },

    // Procesa los meses disponibles
    parsedAvailableMonths() {
      const result = {};

      // Si no hay datos disponibles, devolver objeto vacío
      if (!this.available_months || !this.available_months.meses) {
        return result;
      }

      // Parsear el string de meses disponibles (formato "2:2019,3:2019,...")
      const monthsData = this.available_months.meses.split(",");

      // Procesar cada entrada mes:año
      monthsData.forEach(item => {
        const [month, year] = item.split(":");

        // Si el año no existe en el resultado, inicializarlo
        if (!result[year]) {
          result[year] = [];
        }

        // Añadir el mes al año correspondiente (convertir a número)
        result[year].push(parseInt(month));
      });

      return result;
    },

    // Años disponibles ordenados de más reciente a más antiguo
    availableYears() {
      // Obtener los años de los meses disponibles
      const years = Object.keys(this.parsedAvailableMonths);

      // Ordenar los años de más reciente a más antiguo
      return years.sort((a, b) => b - a);
    },

    // Variable computada para el label del periodo seleccionado
    periodLabel() {
      let monthName = "";

      switch (this.sales_period) {
        case "current_month":
          return `${this.this_month} ${this.this_year}`;
        case "current_year":
          return `${this.this_year}`;
        case "past":
          if (!this.sales_period_month || !this.sales_period_year)
            return this.$t("select");
          monthName = this.getMonthName(this.sales_period_month);
          return `${monthName} ${this.sales_period_year}`;
        case "past_year":
          if (!this.sales_period_year) return this.$t("select");
          return `${this.$t("year")} ${this.sales_period_year}`;
        default:
          return this.$t("select");
      }
    },

    // Variable computada para el label de comparación
    compareLabel() {
      let hotel = null;

      switch (this.sales_vs) {
        case "presupuesto":
          return this.$t("bud");
        case "ano_pasado":
          return this.$t("Last_year");
        case "otro_hotel":
          hotel = this.hotels.find(h => h.id === this.sales_hotel_vs);
          return `${this.$t("Restaurant")} - ${hotel ? hotel.name : ""}`;
        default:
          return this.$t("select");
      }
    },

    // Lista de meses para selector
    monthOptions() {
      const months = [];
      for (let i = 1; i <= 12; i++) {
        months.push({
          number: i,
          name: Vue.moment()
            .month(i - 1)
            .format("MMMM")
        });
      }
      return months;
    },

    // Obtiene el grupo actualmente seleccionado
    currentRestaurantGroupData() {
      if (!this.currentRestaurantGroup) {
        return null;
      }
      return this.hotels.find(
        hotel => hotel.id === this.currentRestaurantGroup
      );
    },
    image_height() {
      return this.sales_period === "current_month" ? 135 : 65;
    },
    ...mapState({
      available_permissions: state => state.user.available_permissions,
      available_months: state => state.restaurant.available_months || {},
      hotels: state => state.hotel.hotels || []
    }),
    ...mapGetters({
      current_hotel: "current_hotel"
    })
  },
  methods: {
    // Abre el diálogo para seleccionar un periodo pasado
    openPastDialog() {
      this.pastPeriodDialog = true;
      this.periodMenu = false;
    },

    // Abre el diálogo para seleccionar otro restaurante
    openRestaurantDialog() {
      // Seleccionar la primera pestaña por defecto
      if (this.restaurantGroups.length > 0) {
        this.activeRestaurantGroupTab = 0;
      }

      this.restaurantDialog = true;
      this.compareMenu = false;
    },

    // Selecciona un restaurante específico
    selectRestaurant(id) {
      this.sales_vs = "otro_hotel";
      this.sales_hotel_vs = id;
      this.restaurantDialog = false;
    },

    // Selecciona un año completo
    selectFullYear(year) {
      if (!year) return;
      this.sales_period = "past";
      this.sales_period_year = year;
      this.sales_period_month = null; // No hay mes específico seleccionado
      this.pastPeriodDialog = false;
    },

    // Selecciona un mes pasado
    selectPastMonth(month, year) {
      this.sales_period = "past";
      this.sales_period_month = month;
      this.sales_period_year = year;
      this.pastPeriodDialog = false;
    },

    // Obtiene los meses disponibles para un año específico
    getMonthsForYear(year) {
      if (!this.parsedAvailableMonths[year]) {
        return [];
      }

      // Devolver los meses ordenados por número
      return [...this.parsedAvailableMonths[year]].sort((a, b) => a - b);
    },

    // Obtiene el nombre del mes a partir de su número
    getMonthName(monthNumber) {
      return Vue.moment()
        .month(monthNumber - 1)
        .format("MMMM");
    },
    ...mapActions([
      "getRestaurantAvailableMonths",
      "getRestaurantAvailableYears"
    ])
  },

  watch: {
    current_hotel: {
      handler() {
        this.getRestaurantAvailableMonths({ hotel_id: this.current_hotel.id });
        this.loading = false;
      }
    }
  },
  mounted() {
    this.loading = true;
    // Cargar meses y años disponibles
    if (this.current_hotel && this.current_hotel.id) {
      this.getRestaurantAvailableMonths({ hotel_id: this.current_hotel.id });
      this.loading = false;
    }

    // Establecer valores por defecto si no están definidos
    if (!this.sales_period) {
      this.sales_period = "current_month";
    }

    if (!this.sales_vs) {
      this.sales_vs = "presupuesto";
    }
  }
};
</script>
